import React from 'react';

import classNames from 'classnames';

import ArrowDown from '~/public/assets/images/svg/arrow-down.svg';

export default function ExpandIcon({ isActive }: { isActive: boolean }) {
  return (
    <div className="flex h-6 w-6 items-center justify-center rounded-[4.5px] bg-silver-400">
      <ArrowDown
        className={classNames(
          'transition-transform duration-300 ease-in-out',
          isActive ? 'rotate-180' : 'rotate-0'
        )}
      />
    </div>
  );
}
